/* Variables coming from webpack.DefinePlugin should be stored in a new
variable before using them. */
const appVersion = application_version;

export const getAppVersion = (): string => appVersion.version;
export const getDist = (): string => appVersion.dist;
export const getSentryReleaseId = (): string => appVersion.sentryReleaseId;
